var map = {
	"./blue50.png": 6257,
	"./blue60.png": 3950,
	"./blue70.png": 7697,
	"./darkblue30.png": 7900,
	"./darkblue50.png": 4116,
	"./darkblue70.png": 3073,
	"./green50.png": 2353,
	"./green60.png": 8984,
	"./green70.png": 3385,
	"./grey40.png": 7051,
	"./grey70.png": 2691,
	"./grey80.png": 3183,
	"./red50.png": 7465,
	"./red60.png": 2290,
	"./red70.png": 1737,
	"./yellow50.png": 7092,
	"./yellow60.png": 1549,
	"./yellow70.png": 5727
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2856;